if (!customElements.get('polight-navigation')) {
  customElements.define('polight-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.trigger = this.querySelector('.pnav__toggle');
      this.dialog = this.querySelector('dialog');
      this.products = this.querySelector('.pnav__products');
      const closeProducts = (focus = false) => {
        if (!this.products?.open) return;
        this.products.open = false;
        if (focus) this.products.querySelector('summary').focus();
      };
      this.trigger.addEventListener('click', () => {
        this.previousOverflow = [document.documentElement.style.overflow, document.body.style.overflow];
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
      }, options);
      this.querySelector('.pnav__close').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => {
        this.unlock();
        this.trigger.setAttribute('aria-expanded', 'false');
        if (this.trigger.getClientRects().length) this.trigger.focus({ preventScroll: true });
      }, options);
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.querySelectorAll('.pnav__localization select').forEach(select => {
        select.addEventListener('change', () => select.form.requestSubmit(), options);
      });
      document.addEventListener('click', event => {
        if (!this.products?.contains(event.target)) closeProducts();
      }, options);
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.products?.open) {
          event.preventDefault();
          closeProducts(true);
        }
      }, options);
      this.products?.addEventListener('focusout', () => {
        queueMicrotask(() => { if (!this.products.contains(document.activeElement)) closeProducts(); });
      }, options);
      const desktop = matchMedia('(min-width: 900px), (min-width: 560px) and (hover: hover) and (pointer: fine)');
      desktop.addEventListener('change', () => {
        closeProducts();
        if (this.dialog.open) this.dialog.close();
      }, options);
      window.addEventListener('pageshow', event => {
        if (event.persisted) { this.dialog.close(); closeProducts(); this.unlock(); }
      }, options);
    }
    unlock() {
      if (!this.previousOverflow) return;
      [document.documentElement.style.overflow, document.body.style.overflow] = this.previousOverflow;
      this.previousOverflow = null;
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.unlock();
    }
  });
}

